import React from 'react';
import './ColumnToggles.css';

function ColumnToggles({ visibleColumns, setVisibleColumns }) {
  const handleToggle = (column) => {
    setVisibleColumns((prev) => ({
      ...prev,
      [column]: !prev[column],
    }));
  };

  return (
    <div className="column-toggle-group">
      <label className="toggle-label">Show columns:</label>
      <div className="toggle-items">
        <div className="toggle-item">
          <input
            type="checkbox"
            id="toggleFingerprint"
            checked={visibleColumns.fingerprint}
            onChange={() => handleToggle('fingerprint')}
          />
          <label htmlFor="toggleFingerprint">Fingerprint SHA256</label>
        </div>
        <div className="toggle-item">
          <input
            type="checkbox"
            id="toggleValidFrom"
            checked={visibleColumns.validFrom}
            onChange={() => handleToggle('validFrom')}
          />
          <label htmlFor="toggleValidFrom">Valid From</label>
        </div>
        <div className="toggle-item">
          <input
            type="checkbox"
            id="toggleValidTo"
            checked={visibleColumns.validTo}
            onChange={() => handleToggle('validTo')}
          />
          <label htmlFor="toggleValidTo">Valid To</label>
        </div>
      </div>
    </div>
  );
}

export default ColumnToggles;

